module.exports = __webpack_public_path__ + "img/alipay.82034fda.jpg";